import {getLanguage} from 'react-switch-lang';

const lang = getLanguage();

const periods = [
  {value: 'DAY', label: (lang === 'eng' ? 'Day' : 'Dan')},
  {value: 'WEEK', label: (lang === 'eng' ? 'Week' : 'Nedjelja')},
  {value: 'MONTH', label: (lang === 'eng' ? 'Month' : 'Mjesec')},
  {value: 'QUARTER', label: (lang === 'eng' ? 'Quarter' : 'Četvrtina godine')},
  {value: 'HALFAYEAR', label: (lang === 'eng' ? 'Half-year' : 'Pola godine')},
  {value: 'YEAR', label: (lang === 'eng' ? 'Year' : 'Godina')},
];

export default periods;